import { useSimpleDeduplicateGetData } from 'src/hooks/useGetData'
import React, { useContext, useMemo } from 'react'

export const CacheStoreContext = React.createContext({ data: {} })

export function useQueryStore (...dependencies) {
  return useMemo(() => {
    return { data: {} }
  }, [...dependencies])
}

export default function useGetWithContext (key, ...args) {
  // FIXME: Hàm lỗi khi payload change, chưa debug được
  const store = useContext(CacheStoreContext)
  return useSimpleDeduplicateGetData(key, store, ...args)
}

export function useGetDataFromStore () {
  const store = useContext(CacheStoreContext)
  return {
    getDataFromStore: (key) => {
      return store.data[key]
    }
  }
}
